import React from 'react';
import {
    ApTimelineMarker,
    ApTimelineRow,
    ApTimelineMetadata,
} from '@accurate-player/accurate-player-components-external';
import {Typography} from '@material-ui/core';

import './MarkerRow.scss';
import classNames from 'classnames';

ApTimelineMarker.register();
ApTimelineRow.register();
ApTimelineMetadata.register();

export interface MarkerRowProps {
    setMarkerRowRef: () => void;
    setMarkerRowContainerRef: () => void;
    onRowClicked: () => void;
    rowLabel: string;
    rowId: string;
    selectedRowId: string;
    hover: boolean;
}

export default function MarkerRow(props: MarkerRowProps) {
    const {
        setMarkerRowRef,
        setMarkerRowContainerRef,
        onRowClicked,
        selectedRowId,
        rowLabel,
        rowId,
        hover,
    } = props;
    const selected = selectedRowId === rowId;
    
    return (
        <ap-timeline-row
            class={classNames('marker-row', {
                selected,
            })}
            onClick={onRowClicked}
            id={rowId}
        >
            <span
                slot="header"
                className="row-header"
            >
                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                    {rowLabel}
                </Typography>
            </span>
            <ap-timeline-metadata
                ref={setMarkerRowContainerRef}
                padding={7}
                class={classNames('marker-metadata', {
                    hover,
                })}
            >
                <ap-timeline-marker ref={setMarkerRowRef} />
            </ap-timeline-metadata>
        </ap-timeline-row>
    );
}
